import React from "react";
import "./Gdhangtet.css";

const TET_PRODUCTS = [
  {
    id: 1,
    qty: 450,
    name: "Set 10 Bao Lì Xì CHIBI",
    price: 4000,
    href: "#",
    img: "/3ht/1.jpeg",
  },
  {
    id: 2,
    qty: 210,
    name: "Set 4 Khánh CHỮ Treo Tường",
    price: 41900,
    href: "#",
    img: "/3ht/2.jpeg",
  },
  {
    id: 3,
    qty: 150,
    name: "Set 2 Khánh Treo Tường DỌC (CMNM-VSNY)",
    price: 33100,
    href: "#",
    img: "/3ht/3.jpeg",
  },
  {
    id: 4,
    qty: 100,
    name: "Bao Lì Xì Lần 6 Ngăn",
    price: 6000,
    href: "#",
    img: "/3ht/4.jpeg",
    soldOut: true,
  },
  {
    id: 5,
    qty: 30,
    name: "Tượng Thần Tài Mini",
    price: 18900,
    href: "#",
    img: "/3ht/5.jpeg",
  },
  {
    id: 6,
    qty: 12,
    name: "Đĩa Sứ Hoa Văn (Combo)",
    price: 25900,
    href: "#",
    img: "/3ht/6.jpeg",
  },
  {
    id: 7,
    qty: 15,
    name: "Hũ Thủy Tinh Đựng Kẹo",
    price: 29900,
    href: "#",
    img: "/3ht/7.jpeg",
    soldOut: true,
  },
  {
    id: 8,
    qty: 40,
    name: "Bình Cắm Hoa Trắng",
    price: 52000,
    href: "#",
    img: "/3ht/8.jpeg",
    cornerIcon: true,
  },
];

function formatVND(n) {
  return new Intl.NumberFormat("vi-VN").format(n) + "đ";
}

export default function Gdhangtet() {
  return (
    <section className="tp">
      <div className="tp__container">
        <h2 className="tp__title">HÀNG TẾT</h2>

        <div className="tp__grid">
          {TET_PRODUCTS.slice(0, 8).map((p) => (
            <a className="tp__card" href={p.href} key={p.id}>
              <div className="tp__media">
                <img
                  className="tp__img"
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                />

                {/* Icon góc trái (tuỳ chọn) */}
                {(p.cornerIcon ?? true) && (
                  <span className="tp__cornerIcon" aria-hidden="true" />
                )}

                {/* Sold out */}
                {p.soldOut && (
                  <span className="tp__soldOut" aria-label="Tạm hết">
                    Tạm hết
                  </span>
                )}
              </div>

              <div className="tp__meta">
                <div className="tp__name">
                  <span className="tp__qty">[{p.qty}]</span>{" "}
                  <span className="tp__nameText">{p.name}</span>
                </div>
                <div className="tp__price">{formatVND(p.price)}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
